// The coverage read projections' function references (bead hf-e6-commitments-coverage-udt.6).
//
// Three queries, no mutations, and that is not an omission: `convex/coverage/` holds
// read-only projections by contract, so there is nothing here for a browser to write.
//
// WHY THE UI SUBSCRIBES TO THESE RATHER THAN COUNTING. Coverage is derived, never
// stored (COV-001), and derived in exactly one place (COV-002). These queries run the
// kernel's engine live on the server; the browser receives a status and two numbers.
// A component that added up `responsible.length` instead would be a second definition
// of "covered", and the two would disagree the first time a commitment went stale.
//
// Convex queries are reactive, so a commitment accepted in another browser re-runs
// these and re-renders the chips with no refresh and no invalidation call. That is
// the bead's reactivity criterion, and it is a property of subscribing rather than
// something this module implements.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

export const coverageQueries = {
  /** One need: the "1 of 2 people confirmed" a volunteer screen shows (NED-012). */
  forNeed: api.coverage.read.forNeed,
  /** Seven local days plus the week's own roll-up — plan health, already counted. */
  forWeek: api.coverage.read.forWeek,
  /** What still wants a person, ordered by the server (please recheck, then soonest). */
  needingAttention: api.coverage.read.needingAttention,
} as const;

/** Inferred from generated Convex types so the browser cannot drift from the backend. */
export type NeedCoverageResult = FunctionReturnType<typeof coverageQueries.forNeed>;
export type WeekCoverageResult = FunctionReturnType<typeof coverageQueries.forWeek>;
export type AttentionResult = FunctionReturnType<typeof coverageQueries.needingAttention>;
